import { render, staticRenderFns } from "./auth0-login-page.vue?vue&type=template&id=d39be7c0&"
import script from "./auth0-login-page.vue?vue&type=script&lang=ts&"
export * from "./auth0-login-page.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports